import type {
  FormBuilder_NodeFragment,
  FormBuilder_ScreenNode,
} from '~/graphql/types';
import isBlockWithOutput from '../typeguards/isBlockWithOutput';

/**
 * Returns the amount of input and select blocks
 * @param {Array<FormBuilder_NodeFragment>} nodes - Nodes
 */
const getOutputBlocksCount = (nodes: Array<FormBuilder_NodeFragment>): number =>
  nodes
    .filter(
      (n): n is FormBuilder_ScreenNode =>
        n.__typename === 'FormBuilder_ScreenNode',
    )
    .reduce(
      (count, { blocks }) => count + blocks.filter(isBlockWithOutput).length,
      0,
    );

export default getOutputBlocksCount;
